import React, { useContext, useEffect, useState } from 'react';
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, PDFViewer, Image } from '@react-pdf/renderer';
import api from '../../Components/Api/Api';
import { UserContext } from '../../context/UserContext';
import { Link, useLocation } from 'react-router-dom';

const styles = StyleSheet.create({
    page: {
        padding: 20,
        fontSize: 10,
        fontFamily: 'Helvetica',
    },
    header: {
        flexDirection: 'row',
    },
    empresa: {
        marginLeft: 30,
        paddingTop: 10
    },
    impresso: {
        marginLeft: 50,
        paddingTop: 10
    },
    title: {
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
    },
    title_orcamento: {
        marginBottom: 5,
        fontSize: 12,
        fontWeight: 'bold',
        textAlign: 'center',
        borderBottomWidth: 1,
    },    
    section: {
        marginTop: 10,
        marginBottom: 5,
    },
    table: {
        width: '100%',
        borderWidth: 1,
        borderColor: '#000',
        marginBottom: 5,
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderBottomColor: '#000',
        paddingVertical: 2,
    },
    assinaturaRow: {
        flexDirection: 'row',
    },
    tableHeader: {
        fontWeight: 'bold',
        backgroundColor: '#d3d3d3',
    },
    tableCell: {
        flex: 1,
        textAlign: 'center',
        paddingHorizontal: 2,
        fontSize: 9,
    },
    footer: {
        marginTop: 10,
        fontSize: 9,
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20,
        backgroundColor: 'transparent',
    },
    button: {
        padding: 10,
        backgroundColor: '#007BFF',
        color: '#fff',
        borderRadius: 5,
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
    },
    button_voltar: {
        marginLeft: 80,
        padding: 10,
        backgroundColor: 'green',
        color: '#fff',
        borderRadius: 5,
        textDecoration: 'none',
        fontSize: 14,
        fontWeight: 'bold',
        border: 'none',
        cursor: 'pointer',
    },
    assinatura: {
        marginTop: 25,
    },
    validade: {
        marginTop: 25,
        flexDirection: 'row'
    },
    logo: {
        width: 90,
        height: 70,
    }
});

const Orcamento = () => {
    const location = useLocation();
    const orcamento = location.state;    
    const {user} = useContext(UserContext)
    const [base64Image, setBase64Image] = useState<string>('');
    let [cliente, setCliente] = useState<any>([]);
    let [empresa, setEmpresa] = useState<any>({});
    let [produtos, setProdutos] = useState<any>([]);
    let [getdado, setGetdado] = useState(true); 
    const [url,setUrl] = useState<string>('')
    const [isImageLoaded, setIsImageLoaded] = useState(false);
    const credentials = btoa(`${user.userRest}:${user.passRest}`); 
    const headers = {
        'Content-Type': 'application/json;charset=UTF-8',
        "Access-Control-Allow-Origin": "*",
        "User-Agent": "PneusBrasil",
        "Accept": "application/json",
        'Authorization': `Basic ${credentials}`
    }    
    const visualizar = () => {
        setTimeout(() => {
          api.get('Getimgdown?Orcamento=999999&foto=1&Origem=Entrada',{headers})
          .then(response => {
                if (response.data.length > 0 ){     
                    const blob = new Blob([response.data], { type: 'image/png' })
                    setUrl('data:image/jpg;base64,'+response.data)   
                    setIsImageLoaded(true);
                    //console.log('data:image/jpg;base64,'+response.data)                 
                }                                   
          });
        }, 10 );       
      }
    const getdados = () => {       
        api.get('Imprimeorcamento?filial='+user.filial+'&numorc='+orcamento,{headers}) //'Condpag?filial='+user.filial)
        .then(response => {
            if (response.data.Orcamento.Empresa.length > 0 ){ 
                //console.log(response.data.Orcamento.Produtos)
                setEmpresa(response.data.Orcamento.Empresa[0])
                setCliente(response.data.Orcamento.Cliente[0])
                setProdutos(response.data.Orcamento.Produtos)
            }else{
                alert("Orçamento não encontrado!")
            }                                                           
        });                                             
    }  
    const MyDocument = () => {
        return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={styles.header}>
                    <View>
                    {isImageLoaded ? (
                                <Image src={url} style={styles.logo} />
                            ) : (
                                <Text>Carregando logo...</Text>
                            )}                        
                        {/* <Image src={url} style={styles.logo} /> */}
                    </View>
                    <View style={styles.empresa}>
                        <Text style={styles.title}>{empresa["empresa"]}</Text>
                        <Text>{empresa["endempresa"]}</Text>
                        <Text>{empresa["bairroemp"]}</Text>
                        <Text>{empresa["cgcemp"]}</Text>
                        <Text>PABX/FAX: {empresa["foneemp"]}</Text>                    
                    </View> 
                    <View style={styles.impresso}>
                    <Text>Impresso: {cliente["dthora"]}</Text>
                    <Text>Consultor(a): {cliente["vendedor"]}</Text>
                    <Text>Orçamento: {cliente["numorc"]}</Text>
                    <Text>DAV: {cliente["doc"]}</Text>
                </View>                                       
                </View>
    
                <View style={styles.section}>
                    <Text style={styles.title_orcamento}>ORÇAMENTO DE VENDA</Text>
                    <Text>Cliente: {cliente["cliente"]}</Text>
                    <Text>Endereço: {cliente["endcli"]}</Text>
                    <Text>Município/U.F.: {cliente["cidadecli"]}</Text>
                    <Text>Dados Veículo: {cliente["veiculo"]}</Text>
                </View>
    
                <View style={styles.table}>
                    <View style={[styles.tableRow, styles.tableHeader]}>
                        <Text style={styles.tableCell}>Item</Text>
                        <Text style={styles.tableCell}>Descrição</Text>
                        <Text style={styles.tableCell}>Atendente</Text>
                        <Text style={styles.tableCell}>Qtde</Text>
                        <Text style={styles.tableCell}>Vlr. Unit.</Text>
                        <Text style={styles.tableCell}>Vlr. Total</Text>
                    </View>
                    {produtos.map((iten: any,i: any) => (
                    <View key={i} style={styles.tableRow}>
                        <Text style={styles.tableCell}>{iten.item}</Text>
                        <Text style={styles.tableCell}>{iten.descricao}</Text>
                        <Text style={styles.tableCell}>{iten.atendente}</Text>
                        <Text style={styles.tableCell}>{iten.quantidade}</Text>
                        <Text style={styles.tableCell}>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(iten.vlunitario)}</Text>
                        <Text style={styles.tableCell}>{Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(iten.vltotal)}</Text>
                    </View>
                    ))}
                </View>
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={[styles.tableCell, { textAlign: 'right', marginRight: 35 }]}>Total Serviços: {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(cliente["vlpedido"])}</Text>    
                </View>    
                <View style={[styles.tableRow, styles.tableHeader]}>
                    <Text style={styles.tableCell}>Sub.Total: {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(cliente["vlpedido"])}</Text>
                    <Text style={styles.tableCell}>Desconto: {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(cliente["vldesconto"])}</Text>
                    <Text style={styles.tableCell}>TOTAL: {Intl.NumberFormat('pt-br', {minimumFractionDigits: 2}).format(cliente["vlpliquido"])}</Text>
                </View>
    
                {/* <View style={styles.section}>
                    <Text>Condição de Pagamento:</Text>
                    <Text>Num. Doc.: 000000841 A2504/02/2025 CC 70,00</Text>
                </View> */}
    
                <View style={styles.assinaturaRow}>
                    <View>
                        <Text style={styles.assinatura}>ASS. Cliente: __________________________________</Text>
                    </View>
                    <View>
                        <Text style={[styles.assinatura,{marginLeft: 20}]}>ASS. Responsável: __________________________________</Text>
                    </View>
                </View>
                <View style={styles.footer}>  
                    <View style={styles.validade}>
                        <Text style={[styles.title,{marginRight: 80}]}>NÃO É VALIDO COMO DOCUMENTO FISCAL</Text>
                        <Text style={[styles.title]}>ORÇAMENTO VÁLIDO ATÉ: {cliente["dtlimite"]}</Text>                                                
                    </View>  
                    <Text>EXIJA SEMPRE O DOCUMENTO FISCAL</Text>
                </View>
            </Page>
        </Document>
        );
    };
    useEffect(() => {       
        if(getdado) {
            getdados(); 
            visualizar();
            setGetdado(false) 
        } 
        }) 
    return (
        <div>
            <PDFViewer style={{ width: '100%', height: '800px' }}>
                <MyDocument />
            </PDFViewer>
            <div style={styles.buttonContainer}>
                <PDFDownloadLink document={<MyDocument />} fileName="orcamento.pdf" style={styles.button}>
                    {({ loading }) => <span>{loading ? 'Carregando documento...' : '📄 Baixar PDF'}</span>}
                </PDFDownloadLink>
                <Link to='/Printer' style={styles.button_voltar}>
                    <span>{'↩️ Voltar'}</span>
                </Link>                
            </div>
        </div>
    );
};

export default Orcamento;
